export const ProviderFinderBox = () => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  border: "none",
  minHeight: "75vh",
  maxHeight: "75vh",
  overflowY: "auto",
});
